import GrabAndGo from '../../catering/catering-order-flow/data/grab-and-go.json';
import QuickBitesAndBevs from '../../catering/catering-order-flow/data/quick-bites-and-bevs.json';
import PerfectPlatters from '../../catering/catering-order-flow/data/perfect-platters.json';
import DecadentDisplays from '../../catering/catering-order-flow/data/decadent-displays.json';
import LightBitesAndWweets from '../../catering/catering-order-flow/data/light-bites-and-sweets.json';
import PassedHorsDoeuvres from '../../catering/catering-order-flow/data/passed-hors-doeuvres.json';
import MorningEssentials from '../../catering/catering-order-flow/data/morning-essentials.json';
import AbundantBuffet from '../../catering/catering-order-flow/data/abundant-buffet.json';
import SaladsAndSandwiches from '../../catering/catering-order-flow/data/salads-and-sandwiches.json';

export default [
  GrabAndGo,
  QuickBitesAndBevs,
  PerfectPlatters,
  DecadentDisplays,
  LightBitesAndWweets,
  PassedHorsDoeuvres,
  MorningEssentials,
  AbundantBuffet,
  SaladsAndSandwiches
];
